module.exports = __webpack_public_path__ + "img/1729147801634-IMG_4682.jpeg.87ac4160.webp";